export function calculateLumFromPower(pow, colourTemperature, lightDistribution) {
	const parameters = {
		'2200K': {
			AsymmetricStreetNarrowRegular: [-0.1, 184.694243, -0.79449748404, 0.0039836509115174],
			AsymmetricStreetMedium: [-0.1, 178.703147, -0.76872564472, 0.0038544295945703],
			AsymmetricStreetWide: [-0.1, 176.175654, -0.75785315, 0.0037999143514831],
			Asymmetric: [-0.1, 175.333156, -0.7542289851, 0.0037817426037875],
			AsymmetricStreetNarrowLong: [-0.1, 168.874006, -0.72644372083, 0.0036424258714535],
		},
		'2700K': {
			AsymmetricStreetNarrowRegular: [1.5, 207.07577, -0.86178138597, 0.0031832591772313],
			AsymmetricStreetMedium: [1.5, 203.355902, -0.84630051673, 0.0031260757431428],
			AsymmetricStreetWide: [1.4, 197.705826, -0.82278675312, 0.0030392203004339],
			Asymmetric: [1.4, 197.705826, -0.82278675312, 0.0030392203004339],
			AsymmetricStreetNarrowLong: [1.4, 191.146865, -0.79549051013, 0.0029383930866755],
		},
		'3000K': {
			AsymmetricStreetNarrowRegular: [-0.2, 216.423101, -0.93098521637, 0.0046680073635586],
			AsymmetricStreetMedium: [-0.2, 209.402788, -0.90078600003, 0.0045165869523739],
			AsymmetricStreetWide: [-0.2, 206.441093, -0.88804570563, 0.0044527064664051],
			Asymmetric: [-0.2, 205.453862, -0.88379894083, 0.0044314129710824],
			AsymmetricStreetNarrowLong: [-0.2, 197.885086, -0.85124041071, 0.0042681628402737],
		},
		'4000K': {
			AsymmetricStreetNarrowRegular: [1.6, 220.105612, -0.91600730976, 0.0033835595925656],
			AsymmetricStreetMedium: [1.6, 216.151678, -0.89955233682, 0.0033227780016943],
			AsymmetricStreetWide: [1.5, 210.146082, -0.8745590152, 0.0032304573485578],
			Asymmetric: [1.5, 210.146082, -0.8745590152, 0.0032304573485578],
			AsymmetricStreetNarrowLong: [1.5, 203.174411, -0.84554520901, 0.0031232857777527],
		}
	};
	if (!lightDistribution) lightDistribution = 'AsymmetricStreetMedium';
	const c = parameters[colourTemperature][lightDistribution];
	if (!c) return pow;
	// console.log(lum, parameters, colourTemperature, lightDistribution, c, c[0] + c[1] * lum + c[2] * Math.pow(lum, 2) + c[3] * Math.pow(lum, 3));

	return c[0] + c[1] * pow + c[2] * Math.pow(pow, 2) + c[3] * Math.pow(pow, 3);
}
